import React from 'react';
import PropTypes from 'prop-types';
import ChargeModalButton from './ChargeModalButton';
import insertCcImage from '../../../../../images/insert-cc.svg';
import { t } from '../../../../modules/infra/i18n';

const ReaderlessChargeButton = ({ onClick, disabled }) => (
  <ChargeModalButton onClick={onClick} disabled={disabled} image={insertCcImage}>
    {t('register:payment.charge_button.third_party_pos')}
    <p className="o-wrapper u-pt zeta u-co-gray u-max-width-360">
      {t('register:payment.charge_button.third_party_pos_description')}
    </p>
  </ChargeModalButton>
);
ReaderlessChargeButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default ReaderlessChargeButton;
